import { useContext } from 'react';

import { UserStateContext } from '../contexts/UserState';

const useUserState = () => {
  return useContext(UserStateContext);
};

export default useUserState;
